import { render, staticRenderFns } from "./ResendPreorderOrderButton.vue?vue&type=template&id=cf3e81ec&scoped=true"
import script from "./ResendPreorderOrderButton.vue?vue&type=script&lang=ts"
export * from "./ResendPreorderOrderButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3e81ec",
  null
  
)

export default component.exports